import {EventEmitter, Inject, Injectable, Output} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {API_BASE_URL} from "./config.service";
import {da} from "date-fns/locale";
import {Subject} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  apiURL: string;
  apiUrl: string;
  @Output() openRentalModelEvent: EventEmitter<any> = new EventEmitter();
  @Output() openCardViewModelEvent: EventEmitter<any> = new EventEmitter();
  @Output() closeCardViewModelEvent: EventEmitter<any> = new EventEmitter();
  @Output() openPaymentModelEvent: EventEmitter<any> = new EventEmitter();
  @Output() openEnvelopModelEvent: EventEmitter<any> = new EventEmitter();
  @Output() openArrearsModelEvent: EventEmitter<any> = new EventEmitter();
  @Output() setPermissionEvent: EventEmitter<any> = new EventEmitter();
  @Output() cardInformationViewModelOpenEvent: EventEmitter<any> = new EventEmitter();
  @Output() openGuarantorEnvilopModelEvent: EventEmitter<any> = new EventEmitter();
  @Output() openGuarantorEnvModelEvent: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient,
              @Inject(API_BASE_URL) apiUrl: string,
  ) {
    this.apiURL = apiUrl;
  }

  openRentalLetter(data) {
    this.openRentalModelEvent.emit(data);
  }

  openCardViewModel(data) {
    this.openCardViewModelEvent.emit(data);
  }

  openPaymentModel(data){
    this.openPaymentModelEvent.emit(data);
  }

  getAPIUrl() {
    return this.apiURL;
  }

  getHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        // Authorization: "Bearer " + localStorage.getItem("authToken"),
      }),
    };
  }

  getHttpOptionWithOutToken() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        // Authorization: "Bearer " + localStorage.getItem("authToken"),
      }),
    };
  }


  closeCardViewModel(data) {
    this.closeCardViewModelEvent.emit(data);
  }

  openEnvelopModel(data) {
    this.openEnvelopModelEvent.emit(data);
  }
  openArrearsModel(data) {
    this.openArrearsModelEvent.emit(data);
  }

  cardInformationViewModelOpen(data) {
    this.cardInformationViewModelOpenEvent.emit(data);
  }
  openGuarantorEnvilopModel(data) {
    this.openGuarantorEnvModelEvent.emit(data);
  }

}
